import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';
import { handleLogout } from './utils/menuUtils';
import { useLocation } from 'react-router-dom';
import { selectFilteredStaticSymbols, setSymbols } from './rtk/slices/tradingSlice/tradingSlice';
import { token } from './utils/config';
import { tradeAccountsList } from './rtk/slices/crm-slices/trade/tradeAccountsList';
import { subscribeToOrderChannel, unsubscribeFromOrderChannel } from './utils/pusher-2';
import { getUser } from './rtk/slices/crm-slices/user/getUserSlice';
import { onAuthStateChanged, signInWithCustomToken } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import useRealTimeBalance from './utils/useRealTimeBalance';
// import { SafeArea } from '@capacitor-community/safe-area';

const IdleMonitor = ({ onIdle }) => {
  let idleRef = React.useRef(0).current;

  React.useEffect(() => {
    const idleInterval = setInterval(timerIncrement, 1000); // 1 minute

    function timerIncrement() {
      idleRef += 1;
      if (idleRef > 3599) {
        // 3600 seconds == 1 hour
        onIdle();
        clearInterval(idleInterval);
      }
    }

    function resetIdleRef() {
      idleRef = 0;
    }

    document.body.addEventListener('mousemove', resetIdleRef);
    document.body.addEventListener('keypress', resetIdleRef);

    return () => {
      document.body.removeEventListener('mousemove', resetIdleRef);
      document.body.removeEventListener('keypress', resetIdleRef);
      clearInterval(idleInterval);
    };
  }, [onIdle]);

  return null;
};

// function logout() {
//   console.log('Logging out due to inactivity');
//   handleLogout();
// }


export function restoreAuthSession(router) {
  const token = localStorage.getItem("token");
  const userLS = JSON.parse(localStorage.getItem("user"));

  if (!token || !userLS) {
    logout(router);
    return;
  }

  // ✅ Wait for Firebase Auth to finish restoring currentUser
  onAuthStateChanged(auth, async (firebaseUser) => {
    if (!firebaseUser) {
      console.log("No user signed in, logging out");
      logout(router);
      return;
    }

    try {
      // ✅ Decode token and check expiry
      const [, payloadBase64] = token.split(".");
      const payload = JSON.parse(atob(payloadBase64));
      const currentTime = Math.floor(Date.now() / 1000);

      if (payload.exp < currentTime) {
        console.warn("Token expired");
        logout(router);
        return;
      }

      // ✅ Fetch latest Firestore data
      const docRef = doc(db, "trade_accounts", userLS.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const updatedUser = { ...docSnap.data(), id: docSnap.id };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        // You can update Redux/context here too if needed
      } else {
        console.log("User document not found");
        logout(router);
      }
    } catch (error) {
      console.error("Session restore failed", error);
      logout(router);
    }
  });
}
export function logout(router) {
  auth.signOut().catch(() => { });
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  router?.navigate?.("/login"); // Optional: redirect to login
}


function App() {





  const dispatch = useDispatch();
  const filteredStaticSymbols = useSelector(selectFilteredStaticSymbols);

  // const { tradeAccount, status } = useSelector((state) => state.tradeAccountsList) || {};
  // const tradeAccountsData = tradeAccount?.data || [];

  // console.log('tradeAccountsData',tradeAccountsData);
  const user = JSON.parse(localStorage.getItem('user'));
  const account = user ? user.account : null;
  const docId = user ? user.id : null;


  useRealTimeBalance(docId);
  // useEffect(() => {
  //     SafeArea.getSafeAreaInsets()
  //         .then(({ insets }) => {
  //             console.log('Safe area insets:', insets);
  //         })
  //         .catch((err) => {
  //             console.error('SafeArea error:', err);
  //         });
  // }, []);

  //  useEffect(() => {

  //         if (account) {
  //             subscribeToOrderChannel(account, (data) => {
  //                 console.log('New order received in Trading:', data);
  //             });
  //             return () => unsubscribeFromOrderChannel(account);
  //         }
  //     }, [account]);

  useEffect(() => {
    // Establish socket connection
    filteredStaticSymbols.forEach(({ symbol, ask, bid, Spread }) => {
      const spreadAsk = ask + Spread
      const spreadBid = bid + Spread
      dispatch(setSymbols({ symbol, bid, ask, spreadAsk, spreadBid }));
    });
    dispatch({ type: 'socket/connect' });

    return () => {
      // Disconnect socket when app unmounts
      dispatch({ type: 'socket/disconnect' });
    };
  }, [dispatch, filteredStaticSymbols]);

  useEffect(() => {
    const account = localStorage.getItem("account");
    if (account) {
      dispatch(getUser(account))

    }

  }, [dispatch])

  // useEffect(() => {
  //   if (token) {
  //     dispatch(tradeAccountsList(token));
  //   }
  // }, [dispatch]);


  // useEffect(() => {
  //   // Check if there is already a user in localStorage
  //   const storedUser = localStorage.getItem('user');

  //   // If there's no stored user, set the default trade account
  //   if (token) {

  //     if (!storedUser) {
  //       if (tradeAccountsData.length === 1) {
  //         // If only one trade account, set it in localStorage
  //         localStorage.setItem('user', JSON.stringify({ account: tradeAccountsData[0].account }));
  //       } else if (tradeAccountsData.length > 1) {
  //         // If multiple trade accounts, set the latest one in localStorage
  //         const latestAccount = tradeAccountsData.reduce((latest, account) => {
  //           return new Date(account.created_at) > new Date(latest.created_at) ? account : latest;
  //         }, tradeAccountsData[0]);

  //         localStorage.setItem('user', JSON.stringify({ account: latestAccount.account }));
  //       }
  //     }

  //   }


  // }, [tradeAccountsData]);


  const location = useLocation()
  const path = location.pathname;

  useEffect(() => {
    const rows = document.querySelectorAll('.row');
    rows.forEach(row => {
      if (path === '/' || path === '/dashboard' || path === '/trade' || path === '/open-position' || path === '/history'
        || path === '/trade?tab=1' || path === '/trade?tab=2' || path === '/trade?tab=3' || path === '/trade?tab=4'
        || path === '/trade?tab=5'
      ) {
        row.style.setProperty('--ra-gutter-x', '0px');
      } else {
        row.style.setProperty('--ra-gutter-x', '1.5rem');
      }
    });
  }, [path]);


  return (
    <React.Fragment>
      <IdleMonitor onIdle={logout} />
      <Route />
    </React.Fragment>
  );
}

export default App;
